import React from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { verifyEmailToken } from "../../../helpers/api/user";

type VerificationStatus = "loading" | "error";

const VerifyEmail = () => {
  document.title = "Legends | Verify email";

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = React.useState<VerificationStatus>("loading");
  const [errorMessage, setErrorMessage] = React.useState("");

  React.useEffect(() => {
    let isMounted = true;
    const token = searchParams.get("token")?.trim() || "";

    const verifyEmail = async () => {
      if (!token) {
        setStatus("error");
        setErrorMessage("Verification token is required.");
        return;
      }

      try {
        await verifyEmailToken(token);
        sessionStorage.setItem("showWelcomePointsModal", "true");
        navigate("/dashboard", { replace: true });
      } catch (error) {
        if (!isMounted) return;

        setStatus("error");
        setErrorMessage(
          error instanceof Error
            ? error.message
            : "Email verification failed. Please request a new verification email."
        );
      }
    };

    verifyEmail();

    return () => {
      isMounted = false;
    };
  }, [navigate, searchParams]);

  React.useEffect(() => {
    document.body.classList.add("home");
    return () => {
      document.body.classList.remove("home");
    };
  }, []);

  return (
    <main className="arena-home arena-home--verify">
      <section className="arena-home__panel arena-home__verify-panel" aria-live="polite">
        <p className="arena-home__eyebrow">EMAIL VERIFICATION</p>
        {status === "loading" ? (
          <>
            <h1>Checking your email</h1>
            <p className="arena-home__copy">Please wait while The Colosseum validates your verification link.</p>
          </>
        ) : (
          <>
            <h1>Verification failed</h1>
            <p className="arena-home__copy">We could not validate this email verification link.</p>
            <div className="arena-home__error">{errorMessage}</div>
            <Link className="arena-home__secondary" to="/">
              Back to home
            </Link>
          </>
        )}
      </section>
    </main>
  );
};

export default VerifyEmail;
